<div class="chunk-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">{{ data.title }}</h2>
    @if (data.hasClose) {
      <button
        mat-icon-button
        class="close-button"
        (click)="onCancel()"
        aria-label="Close"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- Modal Content -->
  <div class="modal-content">
    <form [formGroup]="chunkForm">
      @if (showNotebookInput) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Workflow Name</mat-label>
          <input
            matInput
            formControlName="notebookName"
            placeholder="Workflow Name"
          />
          @if (chunkForm.get("notebookName")?.hasError("required")) {
            <mat-error> Workflow Name is required </mat-error>
          }
        </mat-form-field>
      }

      @if (mode === "edit") {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Default state</mat-label>
          <textarea
            matInput
            formControlName="defaultState"
            placeholder="Default workflow state"
            rows="3"
          ></textarea>
        </mat-form-field>
      }

      @if (mode === "edit") {
        <div class="workflow-toggle-section">
          <div class="toggle-header">
            <mat-slide-toggle formControlName="headlessOnly">
              Routine-only workflow
            </mat-slide-toggle>
            <button
              mat-icon-button
              type="button"
              [matTooltip]="routineOnlyHelpText"
              aria-label="Routine-only workflow help"
            >
              <mat-icon>info</mat-icon>
            </button>
          </div>
          <p class="toggle-help">{{ routineOnlyHelpText }}</p>
        </div>
      }

      @if (mode === "create") {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Chunk Name</mat-label>
          <input matInput formControlName="name" placeholder="Chunk Name" />
          @if (chunkForm.get("name")?.hasError("required")) {
            <mat-error> Name is required </mat-error>
          }
          @if (chunkForm.get("name")?.hasError("nonUniqueName")) {
            <mat-error> Name must be unique </mat-error>
          }
        </mat-form-field>
      }

      @if (mode === "create") {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Type</mat-label>
          <mat-select formControlName="steptypeId">
            @for (type of chunkTypeList(); track type.steptypeId) {
              <mat-option [value]="type.steptypeId">
                {{ type.name }}
              </mat-option>
            }
          </mat-select>
          @if (chunkForm.get("steptypeId")?.hasError("required")) {
            <mat-error> Type is required </mat-error>
          }
        </mat-form-field>
      }

      @if (mode === "create") {
        <div class="description-section">
          <label class="description-label">Description</label>
          <app-code-editor
            class="code-editor"
            (updateContent)="updateContent($event)"
            (startEdit)="setFormTouched()"
            mode="markdown"
            [content]="chunkForm.value.description"
          ></app-code-editor>
        </div>
      }
    </form>
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    <button class="cancel-button" (click)="onCancel()">Cancel</button>
    <button
      class="save-button"
      (click)="onSave()"
      [disabled]="!chunkForm.valid"
    >
      {{ showNotebookInput && mode === "create" ? "Create" : "Save" }}
    </button>
  </div>
</div>
